import moment from 'moment';
import dateUtil from "./date";

Array.prototype.remove_by_value = function(val) {
    for (var i = 0; i < this.length; i++) {
      if (this[i] === val) {
        this.splice(i, 1);
        i--;
      }
    }
    return this;
  }

  Array.prototype.add_by_value = function(val) {
    var found = false;
    if(!this.includes(val)){
      this.push(val);
    }
    return this;
  }

const offerUtil = {

    leveling_filter: (offer) => {
      var allow, lev_filter, pos, allowlist, new_list, a_keys
      allow = { 
        0: ["Z","D", "H", "B"], 
        1: ["F", "E", "L", "N", "C", "I", "O"], 
        2: ["V1", "V2"], 
        4: ["G1", "G2"],  
      };

      pos = Object.keys(allow);
      lev_filter = offer.leveling_list.filter(function(itm){
        return pos.indexOf(itm) > -1;
      });
      /*
      //console.log("LVLFILTER");
      //console.log(lev_filter);
      //console.log("LVLFILTER");
      */

      allowlist = [];
      for (const [key, value] of Object.entries(allow)) {
        if(lev_filter.includes(key)){
          for (const [myv] of Object.values(value)) {
            allowlist.push(myv);
          }
        }
      }

      
    //  //console.log("allowlist");
    //  //console.log(allowlist);
    //  //console.log("allowlist");
      

      a_keys = Object.values(allowlist);
      new_list = offer.leveling_type_list.filter(function(itm){
        return a_keys.indexOf(itm) > -1;
      });

     // //console.log(new_list);
      offer.leveling_type_list = new_list;
    //  //console.log(offer.leveling_type_list);
    },

    apply_rules: (offer) => {

      offerUtil.leveling_filter(offer);
      var holders_list, leveling_list, leveling_type_list, set_sf;
      switch (offer.is_company) {
        case true:
        //  //console.log('customer is company');
          holders_list = ["N", "C", "L", "G", "I", "W", "S"];
//          leveling_list = ["0", "1", "2", "3", "4", "5", "6", "7"];
          offer.leveling_type_list = ["", "Z", "E", "L", "N", "D", "O", "H", "B", "C", "I", "F", "V1", "V2"];
          if (offerUtil.holder_registration_prior_insurance_start(offer)) {
            offer.leveling_type_list.remove_by_value("V2");
           // //console.log('holder_registration_prior_insurance_start');
          }
          break;
        case false:
      //    //console.log('customer is private');
          holders_list = ["N", "P", "K", "L", "S", "C", "G"];
//          leveling_list = ["0", "1", "2", "3", "4"];
          offer.leveling_type_list = ["", "Z", "E", "L", "N", "D", "O", "H", "B", "C", "I", "F", "V1", "V2", "G1", "G2"];
          if (offerUtil.holder_registration_prior_insurance_start(offer)) {
            offer.leveling_type_list.remove_by_value("V2");
         //   //console.log('holder_registration_prior_insurance_start');
          }
          switch (offerUtil.has_divergent_holder(offer)) {
            case true:
              offer.leveling_type_list.remove_by_value("B");
       //       //console.log('has divergent holder');
              if (offerUtil.holder_household_member(offer)) {
         //       //console.log('holder_household_member');
                if (offerUtil.all_ages_over_23(offer)) {
           //         //console.log('all_ages_over_23');
                    offer.leveling_type_list.add_by_value("D");
                }
              }
              break;
            case false:
              //console.log('no divergent holder');
              offer.leveling_type_list.remove_by_value("B");
              if (offerUtil.holder_is_only_driver(offer)) {
                //console.log('holder_is_only_driver');
                if (offerUtil.age_over_23(offer)) {
                  offer.leveling_type_list.add_by_value("B");
                  //console.log('TRUE: all_ages_over_23');
                }
              }
              if (!offerUtil.all_ages_over_23(offer)) {
                offer.leveling_type_list.remove_by_value("H");
                //console.log('FALSE: all_ages_over_23');
              }
          }
          switch (offerUtil.has_divergent_holder(offer)) {
            case true:
              if (!offerUtil.age_over_23(offer)) {
                offer.leveling_type_list.remove_by_value("C");
                offer.leveling_type_list.remove_by_value("I");
                if (offerUtil.holder_household_member(offer)) {
                  if (offerUtil.youngest_driver_over_23(offer)) {
                    offer.leveling_type_list.remove_by_value("O");
                  }
                }
              }
              break;
            case false:
              if (!offerUtil.all_ages_over_23(offer)) {
                offer.leveling_type_list.remove_by_value("C");
                offer.leveling_type_list.remove_by_value("I");
              }
          }
      }

      if (!offerUtil.all_ages_over_23(offer)) {
     //   //console.log("all_ages_over_23 -> false");
        offer.leveling_type_list.remove_by_value("D");
        offer.leveling_type_list.remove_by_value("H");
        offer.leveling_type_list.remove_by_value("B");
      }
      else{
      //  //console.log("all_ages_over_23 -> true");
        offer.leveling_type_list.add_by_value("D");
        offer.leveling_type_list.add_by_value("H");
        offer.leveling_type_list.add_by_value("B");
      }
      //console.log('removing stuff from select if items no available anymore');

      /*
      if (!leveling_type_list.includes($(".einstufung_2").find(":selected").val())) {
        $(".einstufung_2 option").prop("selected", false);
        $('.einstufung_2').prop('selectedIndex', 0);
      }
      */
      holders_list = [offer.holder_id];

      /*
      set_selection(leveling_type_list, 'offer_kravag_einstufung_type');
      set_selection(leveling_list, 'offer_kravag_einstufung_parent');
      set_selection(holders_list, 'offer_holder_id');
      */

      //console.log("LASTLIST 1");
      //console.log(offer.leveling_type_list);

     // return true;



    switch (offer.is_company) {
      // company customer
      case true:
        switch (offer.is_car) {
          case true:
            offerUtil.filter_car_company_rules(offer);
          break;
          case false:
            offerUtil.filter_van_company_rules(offer);
          break;
        }
      break;
      // private customer
      case false:
        switch (offer.is_car) {
          case true:
            offerUtil.filter_car_private_rules(offer);
          break;
          case false:
            offerUtil.filter_van_private_rules(offer);
          break;
        }
      break;
    }

      // abfrage versciherwechsel
        /*
        else{
          /**
           * 
           *     
    0 => {
      "B" => "Angleichungsregelung (Min. SF 9 in KH und VK)"
    },

    1 => {
      "F" => "Führerscheinregel (SF 1/2)",
      "E" => "Ehegattenregel (SF 1)",
      "L" => "Eltern-/Kindregel (SF 1)",
      "N" => "ohne Vorvertrag", 
      "C" => "Kundenkindregel SF 5",
      "I" => "Partnerregel max. SF 8  (Min. SF 4)",
      "O" => "Partnerregel (SF 3)"
    },
           * 
           * 
           * 
          */
         //console.log("LASTLIST 4");
         //console.log(offer.leveling_type_list);
//          if
    //      offer.leveling_type_list.remove_by_value("B");
  //        offer.leveling_type_list.add_by_value("B");
  
 
    //  //console.log(holders_list);
      ////console.log(leveling_list);
      //console.log(offer.leveling_type_list);
      ////console.log('seeting lists');

      //console.log("LEVELING!!!!!!");
      ////console.log(offer.leveling_type_list[0]);
      //offer.leveling_type = offer.leveling_type_list[0];
      ////console.log('leveling TYPE SELs');
      //console.log(offer.leveling_type);
      //offer.leveling_list = leveling_list;
      //offer.leveling_type_list = leveling_type_list;
      return //console.log('end of cheks');
    },

    filter_car_private_rules(offer){
      console.log("filter_car_private_rules");
      console.log("customer_has_free_sfr: "+offer.customer_has_free_sfr);
      console.log("has_second_vehicle: "+offer.has_second_vehicle);
      if (offer.customer_has_free_sfr != 1 || offer.customer_has_free_sfr != true) {
        
        if (offer.has_second_vehicle != 1 || offer.has_second_vehicle != true) {
            if (offerUtil.license_age(offer) > 1) {
                offer.leveling_type_list = ["F"];
                offerUtil.set_sf_class(offer, 0.5);
                offer.leveling_type = "F";
            }
            else {
                offer.leveling_type_list = ["N"];
                offerUtil.set_sf_class(offer, 0);
                offer.leveling_type = "N";
            }
        }
        else {
          console.log("sf_holder_sf: "+offer.sf_holder_sf);
          console.log("all_ages_over_23: "+offerUtil.all_ages_over_23(offer));
          console.log("sf_holder_insurance_is_internal: "+offerUtil.sf_holder_insurance_is_internal(offer));
          console.log("insurance_id: "+offer.insurance_id);

            if (offer.sf_holder_sf >= 1 && offer.sf_holder_sf <= 55) {
                offer.leveling_type_list = ["Z"];
                offer.leveling_type = "Z";
                offerUtil.set_sf_class(offer, 1);
            }
    
            if (offer.sf_holder_sf >= 3 && offerUtil.all_ages_over_23(offer)) {
                offer.leveling_type_list = ["D"];
                offer.leveling_type = "D";
                offerUtil.set_sf_class(offer, 3);
            }
            /*
            if (offer.sf_holder_sf >= 4 && offerUtil.all_ages_over_23(offer) && offerUtil.sf_holder_insurance_is_internal(offer)) {
                var set_sf = 0;
                offer.leveling_type_list = ["H"];
                offer.leveling_type = "H";
                if (offer.sf_holder_sf <= 8) {
                    set_sf = offer.sf_holder_sf;
                }
                else {
                    set_sf = 8
                }
                offerUtil.set_sf_class(offer, set_sf);
            }
            */
        }
      }
      else {
        offer.leveling_type_list = ["V2"];
        offer.leveling_type = "V2";
      }
    },
    // wenn zulassungsdatum auf den halter unterscheidlich zu versicherungsbeginn dann V1 -> versichererwechsel ansonsten V2
    filter_car_company_rules(offer){
      if (offer.customer_has_free_sfr != 1 || offer.customer_has_free_sfr != true) {
        if (offer.has_second_vehicle != 1 || offer.has_second_vehicle != true) {
            offer.leveling_type_list = ["N"];
            offerUtil.set_sf_class(offer, 0);
            offer.leveling_type = "N";
        }
        else {
            if (offer.sf_holder_sf >= 1 && offer.sf_holder_sf <= 55) {
                offer.leveling_type_list = ["Z"];
                offer.leveling_type = "Z";
                offerUtil.set_sf_class(offer, 1);
            }
    
            if (offer.sf_holder_sf >= 3 && offerUtil.all_ages_over_23(offer)) {
                offer.leveling_type_list = ["D"];
                offer.leveling_type = "D";
                offerUtil.set_sf_class(offer, 3);
            }
        }
      }
      else {
        offer.leveling_type_list = ["V2"];
        offer.leveling_type = "V2";
      }
    },
    filter_van_private_rules(offer){
      if (offer.customer_has_free_sfr != 1 || offer.customer_has_free_sfr != true) {
        if (offer.has_second_vehicle != 1 || offer.has_second_vehicle != true) {
            if (offerUtil.license_age(offer) > 1) {
                offer.leveling_type_list = ["F"];
                offerUtil.set_sf_class(offer, 0.5);
                offer.leveling_type = "F";
            }
            else {
                offer.leveling_type_list = ["N"];
                offerUtil.set_sf_class(offer, 0);
                offer.leveling_type = "N";
            }
        }
        else {
            if (offer.sf_holder_sf >= 1 && offer.sf_holder_sf <= 55) {
                offer.leveling_type_list = ["Z"];
                offer.leveling_type = "Z";
                offerUtil.set_sf_class(offer, 1);
            }
    
            if (offer.sf_holder_sf >= 3 && offerUtil.all_ages_over_23(offer)) {
                offer.leveling_type_list = ["D"];
                offer.leveling_type = "D";
                offerUtil.set_sf_class(offer, 2);
            }
        }
      }
      else {
          offer.leveling_type_list = ["V2"];
          offer.leveling_type = "V2";
      }
    },
    filter_van_company_rules(offer){
      if (offer.customer_has_free_sfr != 1 || offer.customer_has_free_sfr != true) {
        if (offer.has_second_vehicle != 1 || offer.has_second_vehicle != true) {
            offer.leveling_type_list = ["N"];
            offerUtil.set_sf_class(offer, 0);
            offer.leveling_type = "N";
        }
        else {
            if (offer.sf_holder_sf >= 1 && offer.sf_holder_sf <= 55) {
                offer.leveling_type_list = ["Z"];
                offer.leveling_type = "Z";
                offerUtil.set_sf_class(offer, 1);
            }
    
            if (offer.sf_holder_sf >= 3 && offerUtil.all_ages_over_23(offer)) {
                offer.leveling_type_list = ["D"];
                offer.leveling_type = "D";
                offerUtil.set_sf_class(offer, 2);
            }
        }
      }
      else {
        offer.leveling_type_list = ["V2"];
        offer.leveling_type = "V2";
      }
    },

    // wenn versicherer oder tarifwechsel dann immer V1


    sf_holder_insurance_is_internal(offer){
        // if kravag, condor, ruv aber NICHT ruv24
        //if(offer.sf_holder_insurance == "Condor Allgemeine Versicherungs-AG"){
        if(offer.insurance_id == 483){
          return true;
        }
        //if(offer.sf_holder_insurance == "KRAVAG KFZ-Versicherung"){
        if(offer.insurance_id == 216){
          return true;
        }
        //if(offer.sf_holder_insurance == "KRAVAG-LOGISTIC KFZ-Versicherung"){
        if(offer.insurance_id == 267){
            return true;
        }
        return false;
    },

    set_sf_if_age(offer) {
        //  this.offer.needs_sf_classes = true;
          if (l_age > 0) {
       //     //console.log("setting sf to 0.5");
            offer.customer_sf = "SF 1/2";
            offer.customer_sf2 = "SF 1/2";
          } else {
         //   //console.log("setting sf to 0");
            offer.customer_sf = 0;
            offer.customer_sf2 = 0;
          }
        //    this.offer.needs_sf_classes = true;
        //    this.offer.sf_classes_enabled = false;
        },

    license_age: (offer) => {
        if (offer.license_date) {
          let currentDate = new Date();
          let birthDate = new Date(offer.license_date);
          let difference = currentDate - birthDate;
          let age = Math.floor(difference / 31557600000);
          //console.log(age);
          return age;
        }
        return "";
    },
    
    formatDate: (date) => {
        return moment(date).format("DD.MM.YYYY")
    },

    holder_registration_prior_insurance_start: (offer) => {
        var hfr, isa;
        isa = new Date(offer.insurance_start);
        hfr = new Date(offer.holder_first_registration);
        if (hfr < isa) {
          return true;
        } else {
          return false;
        }
      },
      
      all_ages_over_23: (offer) => {
        if (offer.holder_only_driver == 1){
          if (dateUtil.age(offer.dob) < 23) {
            return false;
          }
          else{
            return true;
          }
        }
        else{
          if (dateUtil.age(offer.youngest_driver_dob) < 23) {
            return false;
          }
          if (dateUtil.age(offer.oldest_driver_dob) < 23) {
            return false;
          }
        }
        return true;
      },
      
      youngest_driver_over_23: (offer) => {
        if (dateUtil.age(offer.youngest_driver_dob) < 23) {
          return false;
        }
        return true;
      },
      
      age_over_23: (offer) => {
        if (dateUtil.age(offer.dob) > 23) {
          return true;
        } else {
          return false;
        }
      },
      
      has_divergent_holder: (offer) => {
        if (offer.holder_id !== "N") {
          return true;
        } else {
          return false;
        }
      },
      
      holder_household_member: (offer) => {
        if (offer.holder_id === "P") {
          return true;
        }
        if (offer.holder_id === "K") {
          return true;
        }
        return false;
      },
      
      holder_is_only_driver: (offer) => {
        return offer.holder_only_driver;
        if (!offerUtil.holder_is_joungest_driver(offer)) {
          return false;
        }
        if (offer.dob !== offer.oldest_driver_dob) {
          return false;
        }
        if (offer.dob !== offer.youngest_driver_dob) {
          return false;
        }
        return true;
      },
      
      holder_is_joungest_driver: (offer) => {
        return offer.dob === offer.youngest_driver_dob;
      },
      
      is_company: (offer) => {
        return offer.is_company;
      },

      set_sf_class: (offer, sf_class) => {
        offer.customer_sf = sf_class;
        offer.customer_sf2 = sf_class;
        return true;
      },

      set_sf_class_range: (offer, sf_start, sf_end) => {

      //  //console.log(offer.sf_classes);

        offer.sf_classes.each(function() {
          var val;
          val = $(this).value;
          if (val > sf_end || val < sf_start) {
            this.disabled = true;
            return true;
          } else {
            this.disabled = false;
            return false;
          }
        })
        /*
        $('#offer_customer_sf option').each(function() {
          var val;
          val = $(this).val();
          if (val > sf_end || val < sf_start) {
            $('#offer_customer_sf option[value="' + val + '"]').prop('hidden', true);
            return $('#offer_customer_sf2 option[value="' + val + '"]').prop('hidden', true);
          } else {
            $('#offer_customer_sf option[value="' + val + '"]').removeProp('hidden');
            return $('#offer_customer_sf2 option[value="' + val + '"]').removeProp('hidden');
          }
        });

        toggle_offer_option_discount_protection_kh(sf_end);
        return toggle_offer_option_discount_protection_fv(sf_end);
        */
       //return true;
      },



      // Validation 
      /*
        customer vlidation
                ],
        sf_holder_sf: 0,
        sf_holder_insurance: '',

        // general data
        is_car: false,
        is_van: false,

        participations: [],
        paymentterms: [],

        participation: 0,
        paymentterm: 0,

        // customer data
        customer_first_name: '',
        customer_last_name: '',
        is_company: false,
        company_name: '',
        nosf: false,
        customer_sf: 0,
        customer_sf2: 0,
        dob: '',
        has_holder: false,
        holder_id: 'N',
        kravag_location_id: '',
        holder_kravag_location_id: '',


        // calc data
        holder_only_driver: true,
        youngest_driver_dob: '',
        oldest_driver_dob: '',
        license_date: '',
        insurance_start: '',
        sf_classes_enabled: false,
        customer_has_free_sfr: 0,
        has_second_vehicle: 0,

      */
      customer_valid: (offer) => {
        var vld = true;
        if(offer.cusomer_first_name == ""){
          vld = false;
        }
        if(offer.cusomer_last_name == ""){
          vld = false;
        }
        if(offer.dob == ""){
          vld = false;
        }
        if(offer.kravag_location_id == ""){
          vld = false;
        }
        if(offer.holder_id == ""){
          vld = false;
        }
        return vld;
      },

      car_valid: (offer) => {
        var vld = true;
        if(offer.hsn == ""){
          vld = false;
        }
        if(offer.tsn == ""){
          vld = false;
        }
        if(offer.mileage == ""){
          vld = false;
        }
        if(offer.new_car_above_max != false || offer.new_car_above_max != 0){
          vld = false;
        }
        if(offer.radio_usage == ""){
          vld = false;
        }
        if(offer.car_first_registration == ""){
          vld = false;
        }
        return vld;
      },

}

export default offerUtil;

